import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { AddressService } from '@src/app/modules/address/address.service';
import { MyProfileService } from '@src/app/modules/my-profile/my-profile.service';
import { CommonService } from '@src/app/services/common.service';
import { TelegramService } from '@src/app/services/telegram.service';
import { UserService } from '@src/app/services/user.service';
import { WalletStatusService } from '@src/app/services/wallet-status.service';
import { SharedModule } from '@src/app/shared/shared.module';
import { Holding20 } from '@src/app/shared/types/address.type';
import { ChainEnum, getChainInfo } from '@src/app/shared/types/wallet-chain.type';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzTableModule } from 'ng-zorro-antd/table';

@Component({
    selector: 'app-address-portfolio',
    standalone: true,
    imports: [CommonModule, SharedModule, NzSkeletonModule, NzTableModule],
    templateUrl: './address-portfolio.component.html',
    styleUrls: ['./address-portfolio.component.less'],
})
export class AddressPortfolioComponent implements OnInit {
    @Input() walletAddress: string;

    ChainEnum = ChainEnum;
    getChainInfo = getChainInfo;

    erc20Tokens: Holding20[];
    top3ERC20Tokens: Holding20[];
    netWorth: number;
    tokenData = new Map<
        string,
        {
            value: number;
            percent: number; // 0.12 -> 12%
        }
    >();

    fetchingData = false;

    get isMe() {
        return this.walletAddress?.toLowerCase() === this.walletStatusService.walletAddress?.toLowerCase();
    }

    get connectWalletVisible() {
        if (this.isMe) {
            // TODO: 确认是否可以优化
            return this.userService.isOnlyTg || (this.tgService.isTGLogin && !this.walletStatusService.isWalletConnected);
        }

        return false;
    }

    constructor(
        private walletStatusService: WalletStatusService,
        private addressService: AddressService,
        private myProfileService: MyProfileService,
        public tgService: TelegramService,
        public commonService: CommonService,
        public userService: UserService
    ) {}

    ngOnInit() {
        if (this.walletAddress) {
            this.fetchAddressTokenHoldings();
        }
    }

    async sync() {
        try {
            this.fetchingData = true;
            await this.myProfileService.refreshAssets();
            await this.fetchAddressTokenHoldings();
        } catch (e) {
            // TODO:
        } finally {
            this.fetchingData = false;
        }
    }

    fetchAddressTokenHoldings() {
        return this.addressService.getAddressTokenHoldings(this.walletAddress).then(data => {
            this.erc20Tokens = data.holdings.filter(item => item.balance > 0).sort((a, b) => b.balance * b.price - a.balance * a.price);
            this.top3ERC20Tokens = this.erc20Tokens.slice(0, 3);

            this.netWorth = this.erc20Tokens.reduce((pre, cur) => pre + (cur.balance * cur.price || 0), 0);
            this.erc20Tokens.forEach(token => {
                this.tokenData.set(`${token.chain_name}${token.token_symbol}`, {
                    value: token.balance * token.price,
                    percent: (token.balance * token.price || 0) / this.netWorth || 0,
                });
            });
        });
    }
}
